
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { CaseColumn, caseColumns } from "@/types/caseColumns"
import api from "@/services/api"
import PdfRichTextEditor from "../Fields/PdfRichTextEditor.vue"
import { FormatMargin, FormatStyle } from "@/types/format.ts"
import { dataTypes } from "@/types/dataType"

@Component({
	components: {
		"rich-text": PdfRichTextEditor
	}
})
export default class RichTextTemplate extends Vue {
	@Prop({ required: true })
	public value!: string | null

	@Prop()
	public templateId!: string;

	@Prop()
	public caseHeader!: string | null;

	@Prop({ default: null })
	public formatFooter!: string | null;

	@Prop()
	public formatMargin!: FormatMargin | null;

	@Prop()
	public formatStyles!: FormatStyle | null;

	private templateFields: any[] = [];

	private get placeholderFields (): any[] {
		if (!this.templateFields) {
			return []
		}

		return this.templateFields.filter(({ field }) => field.dataType && field.dataType !== dataTypes.FileOnly && field.dataType !== dataTypes.DataObject)
			.map(({ field }) => {
				return {
					label: field.title,
					key: "fields." + field.id,
					fieldId: field.id,
					dataType: field.dataType,
					dataSourceId: field.dataSourceId,
					description: field.description,
					dynamicField: true,
					fieldExtensions: field.extensions
				} as CaseColumn
			})
	}

	private get sections (): { id: string, label: string } [] {
		if (!this.templateFields) {
			return []
		}

		let sections: string[] = []
		this.templateFields.forEach(f => {
			if (!sections.includes(f.section)) {
				sections.push(f.section)
			}
		})

		return sections.map(s => {
			return {
				id: `section.${s}`,
				label: s
			}
		})
	}

	private get dataObjectPlaceholders (): { id: string, label: string } [] {
		if (!this.templateFields) {
			return []
		}

		return this.templateFields
			.map(field => field.field)
			.filter(field => field?.dataType === dataTypes.DataObject)
			.map(field => { return { id: `fields.${field.id}`, label: field.title } })
	}

	private async mounted () {
		await this.getTemplateFields()
	}

	@Watch("templateId")
	private async getTemplateFields (): Promise<void> {
		if (this.templateId == null) {
			this.templateFields = []
			return
		}
		const templateFields = await api.categoryFields(this.templateId as string)
		this.templateFields = templateFields
	}

	@Prop({ default: () => [] })
	public additionalFields!: { id: string, label: string }[]

	public get placeholders (): { id: string, label: string }[] {
		return [
			...this.additionalFields,
			...caseColumns.map(c => ({ id: c.displayKey || c.key, label: c.label })),
			...this.placeholderFields.map(f => ({ id: f.key, label: f.label }))
		]
	}
}
